import React from "react";
import { Row, Col } from "reactstrap";
import "./checkoutResponse.css";

const StripeSubscriptionCheckoutSuccess = () => {
  return (
    <div className="bl-back-image">
      <Row>
        <Col xl="12" lg="12" md="12" sm="12" xm="12" style={{ marginTop: "10%" }}>
          <div>
            <h1 className="text-center text-success text-congrats">
              Subscription Successful :)
            </h1>

            <div className="text-center pl-2 pr-2" style={{ fontSize: "20px", marginTop: "40px" }}>
              <p>
                Thank you for subscribing. Your plan will be activated on your account shortly.
              </p>
            </div>

            <div className="text-center mt-5">
              <a href="/subscription" className="btn btn-primary btn-lg mr-3">
                <span className="fas fa-credit-card pr-2"></span>
                View Subscription
              </a>
              <a href="/dashboard" className="btn btn-outline-primary btn-lg">
                <span className="fas fa-home pr-2"></span>
                Return to Dashboard
              </a>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default StripeSubscriptionCheckoutSuccess;
